import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
    resolveStockIconUrl,
    resolveStockLogoUrl,
    buildStockIconUrlFromSymbol,
    buildDefaultStockIconUrl,
} from 'utils/stockLogoUtils';

/**
 * Muestra logo/icono de acción con fallback a S3 (SYMBOL_ico.png, luego ebi_proyect.jpg).
 */
export default function StockAvatar({
    item,
    symbol,
    className = 'avatar-sm',
    alt,
}) {
    const sym = String(symbol || item?.symbol || '').trim().toUpperCase();
    const merged = { ...item, symbol: sym };

    const [src, setSrc] = useState(
        () => resolveStockIconUrl(merged) || buildDefaultStockIconUrl()
    );
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setSrc(resolveStockIconUrl(merged) || buildDefaultStockIconUrl());
        setFailed(false);
    }, [item?.icon_url, item?.logo_url, sym]);

    const handleError = () => {
        const logo = resolveStockLogoUrl(merged);
        const icon = resolveStockIconUrl(merged);
        const symbolUrl = buildStockIconUrlFromSymbol(sym);
        const defaultUrl = buildDefaultStockIconUrl();

        if (src === logo && icon && icon !== logo) {
            setSrc(icon);
            return;
        }
        if (src !== symbolUrl && symbolUrl) {
            setSrc(symbolUrl);
            return;
        }
        if (src !== defaultUrl) {
            setSrc(defaultUrl);
            return;
        }
        setFailed(true);
    };

    if (failed) {
        return (
            <div className={`${className} stock-logo-fallback`} aria-hidden="true">
                {(sym || '?').slice(0, 3)}
            </div>
        );
    }

    return (
        <img
            className={className}
            src={src}
            alt={alt || sym || 'stock'}
            onError={handleError}
        />
    );
}

StockAvatar.propTypes = {
    item: PropTypes.object,
    symbol: PropTypes.string,
    className: PropTypes.string,
    alt: PropTypes.string,
};
